// extracted by mini-css-extract-plugin
export default {"tableContainer":"UserRefundsTable_tableContainer__Q6DCB","tableBodyContainer":"UserRefundsTable_tableBodyContainer__RRGb4"};